export default "__VITE_ASSET__Di8VOq1p__"